// Shared formatting utilities

/**
 * Format number with locale-aware separators
 * @example formatNumber(1234567) => "1,234,567" (en-US)
 */
export function formatNumber(num: number): string {
  return num.toLocaleString();
}

/**
 * Format character count for display
 * @example formatCharCount(1500) => "1.5K"
 * @example formatCharCount(15000) => "15K"
 * @example formatCharCount(500) => "500"
 */
export function formatCharCount(count: number): string {
  if (count < 1000) return `${count}`;
  if (count < 10000) return `${(count / 1000).toFixed(1)}K`;
  return `${Math.round(count / 1000)}K`;
}
